import { render, staticRenderFns } from "./EditProduct.vue?vue&type=template&id=0baad43a&scoped=true&"
import script from "./EditProduct.vue?vue&type=script&lang=ts&"
export * from "./EditProduct.vue?vue&type=script&lang=ts&"
import style0 from "./EditProduct.vue?vue&type=style&index=0&id=0baad43a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0baad43a",
  null
  
)

export default component.exports